export default {
  // 表格列标题
  transactionHash: "交易哈希",
  sender: "发起方",
  receiver: "接收方",
  currency: "币种",
  transactionAmount: "交易数量",
  transactionTime: "交易时间",

  // 加载和状态
  loading: "拼命加载中",
  noData: "暂无数据",
  tooMuchData: "当前地址交易数据过度，仅支持输入发送方/接收方地址的条件查询",

  // 下载
  downloadDetails: "下载数据明细",
  downloadNote: "注：最多可下载10万条数据",

  // 消息提示
  copySuccess: "复制成功",
};
